import { render } from "./collection-page.vue?vue&type=template&id=2e1acf40"
import script from "./collection-page.vue?vue&type=script&lang=js"
export * from "./collection-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__